module.exports = __webpack_public_path__ + "img/fnf.098b253e.jpg";